import {
    ALGOLIA_APP_ID,
    ALGOLIA_SEARCH_KEY,
    ALGOLIA_INDEX_BY_TIMESTAMP
} from "../search/constants";

import algoliasearch from "algoliasearch/lite";
const TimestampThreshold = 2 * 60 * 60 * 1000; // 2 hours

export default class MixedRecommendedWidget {

    static create(el) {
        new MixedRecommendedWidget(el);
    }

    constructor(el) {
        this.el = el;
        this.clientId = ALGOLIA_APP_ID;
        this.apiKey = ALGOLIA_SEARCH_KEY;
        this.indexName = window.search_index_timestamp || ALGOLIA_INDEX_BY_TIMESTAMP;
        this.init();
    }

    init() {
        this.timestamp = parseInt(this.el.dataset.timestamp, 10);
        if(this.timestamp) {
            const currentTimestamp = Math.floor(Date.now() / 1000);
            const timeDelta = currentTimestamp - this.timestamp;

            if(timeDelta < TimestampThreshold) {
                return;
            }
        }

        this.postsHit = parseInt(this.el.dataset.feedCount, 10);
        this.postTypes = this.el.dataset.types.split(',');
        this.terms = this.el.dataset.terms.split(',');
        this.notIn = this.el.dataset.notIn;
        this.type = this.el.dataset.recommendedWidget;

        this.client = algoliasearch(this.clientId, this.apiKey);
        this.index = this.client.initIndex(this.indexName);

        this.loadPostsFromAlgolia();
    }

    loadPostsFromAlgolia() {
        let terms = [];
        let types = this.postTypes.map(type => `type:${type}`);
        let facets = ['is_hidden', 'type', 'has_password', 'hide_from_news_latest'];

        if(this.type === 'post' || this.type === 'newsletter') {
            terms = this.terms.map(term => `categories_slugs:${term}`);
            facets.push('categories_slugs');
        }

        if(this.type === 'podcast') {
            terms = this.terms.map(term => `show_slug:${term}`);
            facets.push('show_slug');
        }

        const options = {
            hitsPerPage: this.postsHit,
            facets: facets,
            facetFilters: [
                `is_hidden:false`,
                `has_password:false`,
                `objectID:-${this.notIn}`,
                terms,
                types,
            ]
        };
        console.log(options);

        this.index.search('', options).then(({ hits, nbPages }) => {
            if (hits.length > 0) {
                this.el.innerHTML = '';
                hits.forEach(hit => {
                    this.el.innerHTML += this.renderPost(hit);
                });
            }
        }).catch(err => {
            console.error(err);
        });
    }

    renderPost(item) {
        return `
            <li>
                <strong class="title"><a href="${item.url}">${item.title}</a></strong>
                <span class="author">${item.author}</span>
                <a href="${item.url}" class="link">Read More</a>
            </li>
        `;
    }
}
